import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';
import { TableRow, TableCell, Radio, Checkbox } from '@material-ui/core';

class ChoiceAnswer extends Component {

    getAnswerContent = (question_id, question_type_id, answer) => {
        const { studentAnswers, selectAnswer } = this.props;
        
        switch(question_type_id)
        {
            case(1): // Multiple Choice
            {
                return (
                    <Radio
                        checked={ studentAnswers[question_id] === answer.header.answer_id }
                        onChange={() => selectAnswer(question_id, question_type_id, answer.header.answer_id)}
                        value={answer.header.answer_id.toString()}
                        name="answer"
                        aria-label="B"
                    />
                );
                break;
            }
            case(4): // Multiple Answer
            {
                return (
                    <Checkbox
                        checked={ (typeof studentAnswers[question_id] !== 'undefined' && studentAnswers[question_id].includes(answer.header.answer_id)) }
                        onChange={() => selectAnswer(question_id, question_type_id, answer.header.answer_id)}
                        value={answer.header.answer_id.toString()}
                        name="answer"
                        aria-label="B"
                    />
                );
                break;
            }
            default: {}
        }
    }

    render() {
        const { answer, question } = this.props;

        if (typeof answer === 'undefined') {
            return <div>Loading...</div>
        }

        return (
            <TableRow>
                <TableCell style={{ width: '10%' }} >
                    {this.getAnswerContent(question.header.question_id, question.header.question_type_id, answer)}
                </TableCell>
                <TableCell>{answer.header.AnswerText}</TableCell>
            </TableRow>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectAnswer: Actions.selectAnswer,
    }, dispatch);
}

function mapStateToProps({ quizApp }) {
    return {
        studentAnswers: quizApp.quizViewer.studentAnswers
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChoiceAnswer)));




// WEBPACK FOOTER //
// src/main/content/quiz/quizViewer/questionType/ChoiceAnswer.js